import { API_BASE_URL } from '../../../config/env'

export const loginUser = async credentials => {
  try {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Login failed')
    }

    const data = await response.json()
    if (data.token) {
      localStorage.setItem('authToken', data.token)
    }
    if (data.user) {
      localStorage.setItem('user', JSON.stringify(data.user))
    }
    return data
  } catch (error) {
    console.error('Login error:', error)
    throw error
  }
}

export const forgotPassword = async emailData => {
  try {
    const response = await fetch(`${API_BASE_URL}/forgot-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData), // Sends { user_email: email }
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to send verification code')
    }

    return await response.json()
  } catch (error) {
    console.error('Forgot password error:', error)
    throw error
  }
}

export const resetPassword = async resetData => {
  try {
    const response = await fetch(`${API_BASE_URL}/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_email: resetData.user_email,
        verification_code: resetData.verification_code,
        newPassword: resetData.newPassword,
      }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to reset password')
    }

    return await response.json()
  } catch (error) {
    console.error('Reset password error:', error)
    throw error
  }
}

export const registerUser = async formData => {
  try {
    const response = await fetch(`${API_BASE_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Registration failed')
    }
    const data = await response.json()

    return data
  } catch (error) {
    console.error('Registration error:', error)
    throw error
  }
}

export const verifyCode = async verificationData => {
  try {
    const response = await fetch(`${API_BASE_URL}/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(verificationData), 
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Verification failed')
    }

    return await response.json()
  } catch (error) {
    console.error('Verification error:', error)
    throw error
  }
}


